import script from "./MusicDownload.vue?vue&type=script&setup=true&lang=js"
export * from "./MusicDownload.vue?vue&type=script&setup=true&lang=js"

import "./MusicDownload.vue?vue&type=style&index=0&id=d0a3e2f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0a3e2f2"]])

export default __exports__